// import fetch_mix from '@/mixins/fetch_mix'
// mixins:[fetch_mix],

const fetch_mix = {
  methods: {
    async fch_getData(call) {
      call.loading = true
      call.loaded = false

      const result = await this.$store.dispatch('api_call', call.conf)

      call.loading = false
      call.loaded = true

      call.status = result?.status
      call.error = result?.status

      const error = !result || !result?.response ? result?.error : null
      call.error = error
      call.canceled = !!error?.canceled

      const data = result?.response?.data || null

      return { call, data, error }
    },
  },
}

export default fetch_mix
